// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Named reference to a cloud provider network service. state holds assignment state for customer services and health status for ingress services. dns is populated for orchestra target services only.
 *
 * @export
 * @interface NetworkServiceDetails
 */
export interface NetworkServiceDetails {
  /**
   *
   * @type {string}
   * @memberof NetworkServiceDetails
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof NetworkServiceDetails
   */
  state?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof NetworkServiceDetails
   */
  publishedDnsRecords?: Array<string>;
}

/**
 * Check if a given object implements the NetworkServiceDetails interface.
 */
export function instanceOfNetworkServiceDetails(
  value: object,
): value is NetworkServiceDetails {
  return true;
}

export function NetworkServiceDetailsFromJSON(
  json: any,
): NetworkServiceDetails {
  return NetworkServiceDetailsFromJSONTyped(json, false);
}

export function NetworkServiceDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NetworkServiceDetails {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    state: json['state'] == null ? undefined : json['state'],
    publishedDnsRecords:
      json['published_dns_records'] == null
        ? undefined
        : json['published_dns_records'],
  };
}

export function NetworkServiceDetailsToJSON(json: any): NetworkServiceDetails {
  return NetworkServiceDetailsToJSONTyped(json, false);
}

export function NetworkServiceDetailsToJSONTyped(
  value?: NetworkServiceDetails | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    state: value['state'],
    published_dns_records: value['publishedDnsRecords'],
  };
}
